import { createBrowserHistory } from 'history';

export default function getHistory() {
  const windowObj = window as any;

  windowObj.browserHistory = windowObj.browserHistory || createBrowserHistory();

  return windowObj.browserHistory;
}
